import { removeFalsy } from "helpers/formatter";
import apiService from "modules/api/apiService";
import {
  FACILITY_OPTIONS_CARDIO_ACTIVITY_LIST,
  FACILITY_OPTIONS_CLASS_EXERCISE_TYPES,
  FACILITY_OPTIONS_CLASS_LIST,
  FACILITY_OPTIONS_SETTINGS,
  SAVE_FACILITY_OPTIONS_CARDIO_ACTIVITY,
  SAVE_FACILITY_OPTIONS_CLASS_LIST,
  SAVE_FACILITY_OPTIONS_SETTINGS,
  TCA_SUPPORT_ENABLED_FLAG,
} from "modules/api/endpoint";
import { API_STATUS } from "modules/api/type";

import {
  CardioActivityListPayload,
  ClassListPayload,
  FacilitySettingsPayload,
} from "./facilityOptionsActions";

export const getFacilitySettings = async (): Promise<FacilitySettingsPayload> | null => {
  const res = await apiService.get(FACILITY_OPTIONS_SETTINGS);
  if (res.status === API_STATUS.success) {
    return res.data.payload;
  }
  return null;
};

export const saveFacilitySettings = async (body): Promise<FacilitySettingsPayload> | null => {
  const res = await apiService.post(SAVE_FACILITY_OPTIONS_SETTINGS, body);
  if (res.status === API_STATUS.success) {
    return res.data.payload;
  }
  return null;
};

export const getCardioActivities = async (
  params = {}
): Promise<CardioActivityListPayload> | null => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";
  const res = await apiService.get(
    `${FACILITY_OPTIONS_CARDIO_ACTIVITY_LIST}${queryParams ? `?${queryParams}` : ""}`
  );
  if (res.status === API_STATUS.success) {
    return res.data.payload;
  }
  return null;
};

export const saveCardioActivities = async (body): Promise<any> | null => {
  const res = await apiService.put(SAVE_FACILITY_OPTIONS_CARDIO_ACTIVITY, body);
  if (res.status === API_STATUS.success) {
    return res.data.payload;
  }
  return null;
};

export const getExerciseTypes = async (): Promise<any> | null => {
  const res = await apiService.get(FACILITY_OPTIONS_CLASS_EXERCISE_TYPES);
  if (res.status === API_STATUS.success) {
    return res.data.payload;
  }
  return null;
};

export const getClassList = async (params = {}): Promise<ClassListPayload> | null => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";
  const res = await apiService.get(
    `${FACILITY_OPTIONS_CLASS_LIST}${queryParams ? `?${queryParams}` : ""}`
  );
  if (res.status === API_STATUS.success) {
    return res.data.payload;
  }
  return null;
};

export const createOrUpdateClassList = async (body): Promise<any> | null => {
  const res = await apiService.post(SAVE_FACILITY_OPTIONS_CLASS_LIST, body);
  if (res.status === API_STATUS.success) {
    return res.data;
  }
  return null;
};

export const deleteClass = async (id): Promise<any> | null => {
  const res = await apiService.del(`${SAVE_FACILITY_OPTIONS_CLASS_LIST}/${id}`);
  if (res.status === API_STATUS.success) {
    return res.data;
  }
  return null;
};

export const getSupportsCoachApproach = async (): Promise<any> | null => {
  try {
    const res = await apiService.get(TCA_SUPPORT_ENABLED_FLAG);
    if (res.status === API_STATUS.success) {
      return res.data.payload;
    }
  } catch (error) {
    //console.log(`Error caught ${JSON.stringify(error)}`);
    return null;
  }
};

export default {
  getClassList,
  getFacilitySettings,
};
